import { createFileRoute } from '@tanstack/react-router'
import { DidAssignmentReportPage } from '@/features/admin/did-assignment-report'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/did-assignment-report/')({
  component: DidAssignmentReportPage,
  beforeLoad: requireRole(['admin']),
})
